import { render } from "./SucessView.vue?vue&type=template&id=66f59a30&scoped=true"
import script from "./SucessView.vue?vue&type=script&lang=js"
export * from "./SucessView.vue?vue&type=script&lang=js"

import "./SucessView.vue?vue&type=style&index=0&id=66f59a30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f59a30"]])

export default __exports__